import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button';
import image7 from './images/image7.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row;
  display: flex;
  // padding: 2px;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const Heading = styled.div`
  font-size: 18px;

  font-weight: 900;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding-bottom: 24px;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 26px;
  }
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;

const Description = styled(Box)`
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #7c8788;
  padding-bottom: 24px;
`;

export const Scaling2 = (): ReactElement => {
  return (
    <Container>
      <ContainerInner>
        <ImageHolder>
          <img alt="" src={image7} />
        </ImageHolder>
        <SubContainer>
          <Heading>
            Scaling financial education for first-time home buyers
          </Heading>
          <Description>
            The Malaysian Credit Counselling and Debt Management Agency (AKPK)
            needed to deliver a mandatory financial education module aimed at
            first-time home buyers applying for the Central Bank of Malaysia’s
            (BNM) RM 1 Billion Fund for Affordable Homes. AKPK was looking for
            an affordable, scalable and more effective solution that could be
            easily implemented nationwide.{' '}
          </Description>
          <ButtonContainer>
            <Button
              variant="secondary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/success-stories-agensi-kaunseling-dan-pengurusan-kredit-akpk/',
                target: '_blank',
              }}
            >
              Read full case study
            </Button>
          </ButtonContainer>
        </SubContainer>
      </ContainerInner>
    </Container>
  );
};
